import { render, staticRenderFns } from "./CustomPointsPanel.vue?vue&type=template&id=4ca5a77e&scoped=true&"
import script from "./CustomPointsPanel.vue?vue&type=script&lang=js&"
export * from "./CustomPointsPanel.vue?vue&type=script&lang=js&"
import style0 from "./CustomPointsPanel.vue?vue&type=style&index=0&id=4ca5a77e&scoped=true&lang=scss&"
import style1 from "./CustomPointsPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5a77e",
  null
  
)

export default component.exports